import { Button } from 'antd';
import cls from 'classnames';
import React, { createElement } from 'react';

import { useLocaleComponent } from '../../hooks/use-locale';
import { usePrefixCls } from '../../hooks/use-prefix-cls';

import useStyle from './style';
import config from './type-config';

interface ExceptionProps {
  type?: '403' | '404' | '500';
  title?: React.ReactNode,
  desc?: React.ReactNode;
  img?: string;
  backText?: React.ReactNode;
  actions?: React.ReactNode;
  linkElement?: string | React.ReactElement;
  redirect?: string;
  className?: string;
}

export const Exception = (props: ExceptionProps) => {
  const locale = useLocaleComponent('Exception');
  const prefixCls = usePrefixCls('exception');
  const [wrapSSR, hashId] = useStyle(prefixCls);
  const {
    className,
    type = '500',
    title,
    desc,
    img,
    backText = locale.backHome,
    actions,
    linkElement = 'a',
    redirect = '/',
  } = props;
  const pageType = type in config ? type : '500';
  const defaultDescription = pageType === '403'
    ? locale.forbidden
    : pageType === '404' ? locale.notFound : locale.serverError;
  return wrapSSR(
    <div className={cls(prefixCls, hashId, className)}>
      <div className={`${prefixCls}-imgBlock`}>
        <div
          className={`${prefixCls}-imgEle`}
          style={{ backgroundImage: `url(${img || config[pageType].img})` }}
        />
      </div>
      <div className={`${prefixCls}-content`}>
        <h1>{title || `${locale.errorTitle} ${pageType}`}</h1>
        <div className={`${prefixCls}-desc`}>{desc || defaultDescription}</div>
        <div className={`${prefixCls}-actions`}>
          {actions
            || createElement(
                linkElement as string | React.ComponentType<{ to: string; href: string }>,
                {
                  to: redirect,
                  href: redirect,
                },
              <Button type="primary">{backText}</Button>,
            )}
        </div>
      </div>
    </div>,
  );
};
